import { useFeatureFlag } from './use-feature-flag';
import { FeatureFlagDeclarations } from '../feature-flag-declarations';

export const useEnableScanPageInitialWeightRead = () => useFeatureFlag(FeatureFlagDeclarations.enableScanInitialWeightRead);
